import React, { useState, useEffect, Fragment } from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import axiosConfig from "../../services/axiosConfig";
import setHeader from "../../components/Functions/setHeader";
import { NoDataFound } from "../../constant";
import NoDataHandler from "../../components/common/NoDataHandler";
import LoadingComponent from "../../components/common/LoadingComponent";

const UserLists = () => {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getData();
    }, []);

    const [filters, setFilters] = useState({
        name: '',
        mobile: '',
        fromDate: '',
        toDate: ''
    });

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters({ ...filters, [name]: value });
    };

    const getData = () => {
        setLoading(true);
        const { name, mobile, fromDate, toDate } = filters;
        const params = new URLSearchParams();

        if (name) params.append("name", name);
        if (mobile) params.append("mobile", mobile);
        if (fromDate) params.append("from_date", fromDate);
        if (toDate) params.append("to_date", toDate);

        axiosConfig.get(`users-list?${params.toString()}`, setHeader()).then((res) => {
            setData(res.data.data);

            setFilters({
                name: '',
                mobile: '',
                fromDate: '',
                toDate: ''
            });
        }).catch((error) => {
            console.log(error, "Error fetching user data");

        }).finally(() =>
            setLoading(false)
        );
    };

    const handleCancel = () => {
        getData();
    };

    const toggleStatus = (id, currentStatus) => {
        const newStatus = currentStatus == 1 ? 0 : 1;

        axiosConfig.post(`update-user-status/${id}`, { status: newStatus }, setHeader())
            .then((res) => {
                if (!res.data.error) {
                    getData();
                }
            })
            .catch((err) => {
                console.error("Failed to update status", err);
            });
    };
    if (loading) {
        return (
            <LoadingComponent />
        );
    }
    if (data.length === 0) {
        return <NoDataHandler title='No Users Fount' />;
    }

    return (
        <Fragment>
            <Breadcrumb title="Users List" parent="User" />
            <div className="container-fluid">

                <div className="row mb-3">
                    <div className="col-md-2">
                        <label>Name</label>
                        <input type="text" className="form-control" name="name" placeholder="Name"
                            value={filters.name} onChange={handleFilterChange} />
                    </div>
                    <div className="col-md-2">
                        <label>Mobile</label>
                        <input type="text" className="form-control" name="mobile" placeholder="Mobile"
                            value={filters.mobile} onChange={handleFilterChange} />
                    </div>
                    <div className="col-md-2">
                        <label>From Date</label>
                        <input type="date" className="form-control" name="fromDate"
                            value={filters.fromDate} onChange={handleFilterChange} />
                    </div>
                    <div className="col-md-2">
                        <label>To Date</label>
                        <input type="date" className="form-control" name="toDate"
                            value={filters.toDate} onChange={handleFilterChange} />
                    </div>
                    <div className="col-md-2 mt-1 d-flex align-items-end gap-2">
                        <button className="btn btn-outline-primary mt-4" onClick={getData}>Filter</button>
                        <button className="btn btn-outline-warning mt-4" onClick={handleCancel}>Cancel</button>
                    </div>

                </div>


                <div className="row">
                    <div className="col-sm-12">
                        <div className="table-responsive">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th scope="col">{"#"}</th>
                                        <th scope="col">{"User Name"}</th>
                                        <th scope="col">{"Name"}</th>
                                        <th scope="col">{"Mobile"}</th>
                                        <th scope="col">{"Email"}</th>
                                        <th scope="col">{"Role"}</th>
                                        <th scope="col">{"Status"}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <th scope="row">{index + 1}</th>
                                                <td>{item.username}</td>
                                                <td>{item.name}</td>
                                                <td>{item.mobile}</td>
                                                <td>{item.email}</td>
                                                <td>{item.role}</td>
                                                <td>
                                                    <div className="form-check form-switch">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            role="switch"
                                                            checked={item.status == 1}
                                                            onChange={() => toggleStatus(item.id, item.status)}
                                                        />
                                                        <label className="form-check-label">
                                                            {item.status == 1 ? 'Active' : 'Inactive'}
                                                        </label>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}

                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>

            </div>
        </Fragment>
    );
};

export default UserLists;